import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { Row, Col } from 'reactstrap';
import FontAwesome from 'react-fontawesome';

import { Field, FormSection } from 'redux-form/immutable';
import * as validations from 'modules/forms/validations';
import { SelectFieldF, TextFieldF } from 'modules/forms/component';

import * as reservasActions from 'modules/reservas/action';

@connect()
class Pasajero extends React.Component {
  buscarUsuario = (val, doc) => {
    if (doc.length >= 7) this.props.dispatch(reservasActions.getByDoc(doc));
  }
  selectText = event => event.target.select()
  render() {
    const { pasajero } = this.props;
    let userType = pasajero.get('abonadoId') ? 'abonado' : pasajero.get('usuarioId') ? 'usuario' : 'usuarioCasual',
    disabledEdit = false;
    if(pasajero.size > 0) userType = pasajero.get('abonadoId') ? 'abonado' : pasajero.get('usuarioId') ? 'usuario' : 'usuarioCasual';
    disabledEdit = userType == 'abonado' || userType == 'usuario' ? true : false;
    return (
      <MaterialUI.Paper zDepth={1} className="container mb-30">
        <FormSection name="usuario">
          <Row>
            <Col md="5">
              <Field
                name={'documento'}
                component={TextFieldF}
                inputProps={{
                  floatingLabelText: 'Documento',
                  hintText: 'Documento del pasajero',
                  fullWidth: true,
                  autoFocus: true
                }}
                onChange={this.buscarUsuario.bind(this)}
                validate={[validations.required, validations.minLength7, validations.maxLength12]}
                />
            </Col>
            <Col md="1">
              {pasajero.size > 0 && <FontAwesome name={userType == 'abonado' ? 'user' : userType == 'usuario' ? 'mobile' : 'user-circle' } className={pasajero.get('abonado') ? 'iconBigBig mt-20' : 'iconBigBig mt-20'}/>}
            </Col>
            <Col md="6">
              <Field
                name={'tipoDoc'}
                component={SelectFieldF}
                inputProps={{
                  fullWidth: true,
                  floatingLabelText: 'Tipo de documento',
                  disabled: disabledEdit
                }}
                >
                <MaterialUI.MenuItem value="DNI" primaryText="DNI" />
                <MaterialUI.MenuItem value="otro" primaryText="Otro" />
              </Field>
            </Col>
            <Col md="6">
              <Field
                name={'nombre'}
                component={TextFieldF}
                inputProps={{
                  fullWidth: true,
                  className: 'capitalize',
                  onFocus: this.selectText,
                  floatingLabelText: 'Nombre',
                  hintText: 'Ingresa el nombre del pasajero',
                  disabled: disabledEdit
                }}
                validate={disabledEdit ? [validations.required] : [validations.required, validations.minLength3,validations.maxLength50]}
                />
            </Col>
            <Col md="6">
              <Field
                name={'apellido'}
                component={TextFieldF}
                inputProps={{
                  hintText: 'Ingresa el apellido del abonado',
                  floatingLabelText: 'Apellido',
                  className: 'capitalize',
                  fullWidth: true,
                  onFocus: this.selectText,
                  disabled: disabledEdit
                }}
                validate={disabledEdit ? [] : [validations.minLength3, validations.maxLength50]}
                />
            </Col>
          </Row>
        </FormSection>
      </MaterialUI.Paper>
    );
  }
}

Pasajero.propTypes = {
  change: PropTypes.func.isRequired // Change de redux-form
};

export default Pasajero;



// WEBPACK FOOTER //
// src/modules/reservas/components/pasajero.js